import React from "react"
import CustomLink from "../../_Atoms/CustomLink"
import RichText from "../../RichText"

const DownloadCard = ({ data }) => {
  const { title, thumbnailUrl, thumbnailAlt, brochureType, intro } = data

  return (
    <div
      className={
        "w-full bg-white overflow-hidden shadow-2xl rounded-[2.4rem] flex flex-col"
      }
    >
      <picture className={"w-full h-80 block overflow-hidden flex-none"}>
        <img
          src={thumbnailUrl}
          className={"block w-full h-full object-cover"}
          alt={thumbnailAlt}
        />
      </picture>

      <div className={"p-12 h-full flex flex-col grow"}>
        <div className={"grow"}>
          <h3 className={"mb-6"}>{title}</h3>
          <RichText data={intro} />
        </div>
        <div className={"justify-self-end"}>
          <CustomLink
            fbTrack="Download"
            type="pdfDownloadBtn"
            label="Download Report"
            brochureType={brochureType}
            color="black"
          />
        </div>
      </div>
    </div>
  )
}

export default DownloadCard
